import { cloneDeep } from 'lodash';
import { RotorTypeDetailActionTypes } from './rotor-type-details-store.actions';
import {
  CorrectionLocationsStepFormData,
  CorrectionMethodStepFormData,
  CalibrationsStepFormData,
  RotorTypeDetailsStore as RotorTypeDetailsState,
  RotorTypeSettingsStepFormData,
  SummaryStepFormData,
  SupportSettingsStepFormData,
  TolerancesStepFormData,
  MeasurementSettingsStepFormData,
} from './rotor-type-details-store.basic';
import { LocationType } from 'src/utils/enums/rotor-type.enum';
import { SectorData } from 'src/utils/interfaces/rotor-type-forms-data.interfaces';
import { Side } from '../steps/correction-locations-step/correction-locations-step.component';
export const RotorTypeDetailsStoreInitial: RotorTypeDetailsState = {
  forms: {
    supportSettingsStep: new SupportSettingsStepFormData(),
    rotorTypeSettingsStep: new RotorTypeSettingsStepFormData(),
    measurementSettingsStep: new MeasurementSettingsStepFormData(),
    correctionMethodStep: new CorrectionMethodStepFormData(),
    correctionLocationsStep: new CorrectionLocationsStepFormData(),
    tolerancesStep: new TolerancesStepFormData(),
    summaryStep: new SummaryStepFormData(),
    calibrationsAndCompensationsStep: new CalibrationsStepFormData(),
  },
};

export function rotorTypeDetailsReducer(
  state: RotorTypeDetailsState = RotorTypeDetailsStoreInitial,
  action
): RotorTypeDetailsState {
  switch (action.type) {
    case RotorTypeDetailActionTypes.SupportSettingsFormUpdate: {
      const newState = cloneDeep(state);

      newState.forms.supportSettingsStep = cloneDeep(action.payload);
      return newState;
    }
    case RotorTypeDetailActionTypes.RotorTypeSettingsFormUpdate: {
      const newState = cloneDeep(state);

      newState.forms.rotorTypeSettingsStep = cloneDeep(action.payload);
      return newState;
    }
    case RotorTypeDetailActionTypes.MeasurementSettingsFormUpdate: {
      const newState = cloneDeep(state);

      newState.forms.measurementSettingsStep = cloneDeep(action.payload);
      return newState;
    }
    case RotorTypeDetailActionTypes.CorrectionMethodFormUpdate: {
      const newState = cloneDeep(state);

      newState.forms.correctionMethodStep = cloneDeep(action.payload);
      return newState;
    }
    case RotorTypeDetailActionTypes.CorrectionLocationsFormUpdate: {
      const newState = cloneDeep(state);
      const oldState = cloneDeep(state);
      newState.forms.correctionLocationsStep = cloneDeep(action.payload);

      const sortAndUpdateSectorIndex = (side: Side): SectorData[] => {
        return (
          action.payload[side]?.sectors?.length === 0
            ? oldState.forms.correctionLocationsStep[side].sectors
            : cloneDeep(action.payload[side].sectors)
        )
          .sort((a, b) => a.startAngle - b.startAngle)
          .map((sector: SectorData, index) => {
            sector.sectorIndex = index;
            return sector;
          });
      };
      // if the user didn't add new sectors (it happens, when the user
      // changes to the Fixed location type, then sectors is getting empty)
      // Sort the sectors by startAngle
      newState.forms.correctionLocationsStep.left.sectors = sortAndUpdateSectorIndex('left');
      newState.forms.correctionLocationsStep.right.sectors = sortAndUpdateSectorIndex('right');
      return newState;
    }
    case RotorTypeDetailActionTypes.TolerancesFormUpdate: {
      const newState = cloneDeep(state);

      newState.forms.tolerancesStep = cloneDeep(action.payload);
      return newState;
    }
    case RotorTypeDetailActionTypes.SummaryFormUpdate: {
      const newState = cloneDeep(state);

      newState.forms.summaryStep = cloneDeep(action.payload);
      return newState;
    }

    case RotorTypeDetailActionTypes.CalibrationsAndCompensationsFormUpdate: {
      const newState = cloneDeep(state);
      newState.forms.calibrationsAndCompensationsStep = cloneDeep(action.payload);
      return newState;
    }
    case RotorTypeDetailActionTypes.ResetRotorTypeForms: {
      const newState = cloneDeep(state);

      newState.forms.summaryStep = new SummaryStepFormData();
      newState.forms.supportSettingsStep = new SupportSettingsStepFormData();
      newState.forms.rotorTypeSettingsStep = new RotorTypeSettingsStepFormData();

      if (action.payload?.keepName) {
        newState.forms.rotorTypeSettingsStep.rotorTypeName =
          state.forms.rotorTypeSettingsStep.rotorTypeName;
      }

      newState.forms.measurementSettingsStep = new MeasurementSettingsStepFormData();
      newState.forms.correctionLocationsStep = new CorrectionLocationsStepFormData();
      newState.forms.tolerancesStep = new TolerancesStepFormData();
      newState.forms.correctionMethodStep = new CorrectionMethodStepFormData();
      newState.forms.calibrationsAndCompensationsStep = new CalibrationsStepFormData();
      return newState;
    }
    case RotorTypeDetailActionTypes.UpdateRotorTypeForms: {
      const newState = cloneDeep(state);

      newState.forms = cloneDeep(action.payload);
      return newState;
    }
    case RotorTypeDetailActionTypes.CopySectors: {
      const newState = cloneDeep(state);
      newState.forms.correctionLocationsStep.left.locationType = LocationType.Sector;
      newState.forms.correctionLocationsStep.right.locationType = LocationType.Sector;
      newState.forms.correctionLocationsStep.right.sectors = cloneDeep(action.sectors);
      newState.forms.correctionLocationsStep.left.sectors = cloneDeep(action.sectors);
      return newState;
    }
  }
  return state;
}
